import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { supabase } from '../lib/supabaseClient';
import { queryKeys } from '../lib/queryClient';

/**
 * Custom hook for checking admin status with caching
 * @returns {Object} Admin status query result
 */
export const useAdminStatus = () => {
  const { user } = useSelector(state => state.auth);
  const userId = user?.id;

  return useQuery({
    queryKey: [queryKeys.auth.admin, userId],
    queryFn: async () => {
      if (!userId) return false;
      
      const { data, error } = await supabase
        .from('user_profiles')
        .select('is_admin')
        .eq('id', userId)
        .single();
      
      if (error) {
        console.error('Error checking admin status:', error);
        return false;
      }
      
      return data?.is_admin === true;
    },
    // Cached admin status will never become stale until logout
    staleTime: Infinity,
    cacheTime: Infinity,
    // Return false if no user is logged in
    enabled: !!userId,
    // Return previous value while refetching
    keepPreviousData: true,
  });
}; 